import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

export const getAuthErrorMessage = (error, fallbackMessage) =>
  error?.body?.error ||
  (typeof error?.body === "string" ? error.body : null) ||
  error?.response?.data?.body?.error ||
  (typeof error?.response?.data?.body === "string"
    ? error.response.data.body
    : null) ||
  error?.response?.data?.error ||
  (typeof error?.response?.data === "string" ? error.response.data : null) ||
  error?.response?.data?.message ||
  error?.message ||
  fallbackMessage;

export const getAuthResponseMessage = (payload, fallbackMessage) => {
  if (typeof payload === "string") {
    return payload;
  }

  if (payload && typeof payload === "object") {
    return payload.success || payload.message || payload.error || fallbackMessage;
  }

  return fallbackMessage;
};

export const unwrapAuthResponseData = (data, fallbackMessage) => {
  if (typeof data?.statusCodeValue !== "number") {
    return data;
  }

  if (data.statusCodeValue >= 400) {
    const error = new Error(getAuthResponseMessage(data.body, fallbackMessage));
    error.statusCode = data.statusCodeValue;
    error.body = data.body || null;
    throw error;
  }

  return data.body;
};

export function createAuthMutationThunk(name, apiFn, options = {}) {
  const { successMessage, errorMessage, mapPayload } = options;

  return createAsyncThunk(`auth/${name}`, async (params, { rejectWithValue }) => {
    try {
      const res = await apiFn(params);
      const payload = unwrapAuthResponseData(res?.data, errorMessage);
      const result = mapPayload ? mapPayload(payload, params) : payload;
      toast.success(getAuthResponseMessage(result, successMessage));
      return result;
    } catch (error) {
      const errorMessageText = getAuthErrorMessage(error, errorMessage);
      toast.error(errorMessageText);
      return rejectWithValue(errorMessageText);
    }
  });
}
